(() => {
  if (window.FPColorsOptimizerSwatchReady) return;
  window.FPColorsOptimizerSwatchReady = true;
  const selector = 'fp-colors-optimizer-swatch [data-fp-connected-product-url]';
  const pointerIntents = new Map();
  document.addEventListener('pointerenter', event => {
    if (event.pointerType !== 'mouse' && event.pointerType !== 'pen') return;
    const item = event.target.closest?.(selector);
    window.FPConnectedProductTransition?.schedulePrefetch(item);
  }, true);
  document.addEventListener('pointerleave', event => {
    if (event.pointerType !== 'mouse' && event.pointerType !== 'pen') return;
    const item = event.target.closest?.(selector);
    if (item && !item.contains(event.relatedTarget)) window.FPConnectedProductTransition?.cancelScheduledPrefetch(item);
  }, true);
  document.addEventListener('focusin', event => {
    if (pointerIntents.size) return;
    const item = event.target.closest?.(selector);
    window.FPConnectedProductTransition?.schedulePrefetch(item);
  });
  document.addEventListener('pointerdown', event => {
    if (event.pointerType !== 'touch' && event.pointerType !== 'pen') return;
    const item = event.target.closest?.(selector);
    if (item) pointerIntents.set(event.pointerId, { item, x: event.clientX, y: event.clientY });
  }, true);
  document.addEventListener('pointermove', event => {
    const intent = pointerIntents.get(event.pointerId);
    if (!intent || Math.hypot(event.clientX - intent.x, event.clientY - intent.y) < 10) return;
    window.FPConnectedProductTransition?.cancelScheduledPrefetch(intent.item);
    pointerIntents.delete(event.pointerId);
  }, true);
  document.addEventListener('pointercancel', event => {
    const intent = pointerIntents.get(event.pointerId);
    if (intent) window.FPConnectedProductTransition?.cancelScheduledPrefetch(intent.item);
    pointerIntents.delete(event.pointerId);
  }, true);
  document.addEventListener('pointerup', event => {
    const intent = pointerIntents.get(event.pointerId);
    pointerIntents.delete(event.pointerId);
    // Start before click, after a completed tap; scrolling never warms a PDP.
    if (intent?.item.contains(event.target)) {
      window.FPConnectedProductTransition?.schedulePrefetch(intent.item, 0);
    }
  }, true);
  document.addEventListener('click', event => {
    const item = event.target.closest?.(selector);
    if (!item || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    if (item.hasAttribute('aria-current')) { event.preventDefault(); return; }
    const transition = window.FPConnectedProductTransition;
    if (!transition) return;
    event.preventDefault();
    const block = item.closest('fp-colors-optimizer-swatch');
    transition.transition(item.href, item.dataset.fpConnectedProductId, {
      showLoading: block?.dataset.fpShowLoading === 'true',
      pendingItem: item,
    });
  });
})();
